import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, r5, rx, sImaginary) {
  var result = Complex.createComplex(r5, r5 * 2 * sImaginary * rx * c1).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexRParallel) {
  return complexRParallel;
}
